const tableBlocks = document.querySelectorAll('.wp-block-table');

if (tableBlocks.length) {
  tableBlocks.forEach((table) => {
    const tableHeader = table.querySelector('thead tr');
    const headerColumns = tableHeader && tableHeader.querySelectorAll('th');
    const tableBody = table.querySelector('tbody');
    const bodyRows = tableBody && tableBody.querySelectorAll('tr');

    if (headerColumns && headerColumns.length) {
      headerColumns.forEach((column, index) => {
        const columnName = column.innerText;

        bodyRows.forEach((row) => {
          const rowColumn = row.children[index];

          if (! rowColumn.hasAttribute('data-label')) {
            rowColumn.setAttribute('data-label', columnName);
          }
        });
      });
    }
  });
}
